import { createAnnualMetricTable } from '../common/annualMetricTable';
export var AgentSalariesTable = createAnnualMetricTable({
  metricKey: 'agentsSalaries',
  titleKey: 'reportRows.agentsSalaries',
  totalLabelKey: 'totalAgentsSalaries',
  unitKey: 'chart.agentsSalaries'
});